import {ApiRouteMap, FastRobotErrorcode, HostRepositoryStateName, RestAPIMethod} from 'constants/dataEnum';
import {throwErrorWithData} from 'lib/errorHelper';
import {callAPI, getBaseURL} from '../../stores/business/commonBusiness';

export const getDownloadBackupData = async () => {
  const baseUrl = getBaseURL(HostRepositoryStateName.INSTRUMENT_CONTROL);
  const response = await callAPI(
    RestAPIMethod.GET,
    baseUrl,
    ApiRouteMap.DOWNLOAD_BACKUP_DATA,
    null,
    null,
    'blob',
    null,
    true,
  );

  if (response?.errorCode && response.errorCode.toLowerCase() !== FastRobotErrorcode.NoError.toLowerCase()) {
    throwErrorWithData('Error in downloading backup data', response);
  }

  return response;
};

export const postUploadRestoreData = async (formData) => {
  const baseUrl = getBaseURL(HostRepositoryStateName.INSTRUMENT_CONTROL);
  const response = await callAPI(RestAPIMethod.POST, baseUrl, ApiRouteMap.UPLOAD_RESTORE_DATA, formData);

  if (response?.errorCode && response.errorCode.toLowerCase() !== FastRobotErrorcode.NoError.toLowerCase()) {
    throwErrorWithData('Error in uploading restore data', response);
  }

  return response;
};

export const postUploadFinalizeRestoreData = async (zipName) => {
  const baseUrl = getBaseURL(HostRepositoryStateName.INSTRUMENT_CONTROL);
  const response = await callAPI(RestAPIMethod.POST, baseUrl, ApiRouteMap.FINALIZE_UPLOAD_RESTORE_DATA, {zipName});

  if (response?.errorCode && response.errorCode.toLowerCase() !== FastRobotErrorcode.NoError.toLowerCase()) {
    throwErrorWithData('Error in finalizing restore data', response);
  }

  return response;
};
